// extracted by mini-css-extract-plugin
export default {"top":"PaymentButtons_top_gk7Qv","buttons":"PaymentButtons_buttons_PlEvm"};